import { render, staticRenderFns } from "./FirstAccess.vue?vue&type=template&id=ef4869c2&"
import script from "./FirstAccess.vue?vue&type=script&lang=js&"
export * from "./FirstAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef4869c2')) {
      api.createRecord('ef4869c2', component.options)
    } else {
      api.reload('ef4869c2', component.options)
    }
    module.hot.accept("./FirstAccess.vue?vue&type=template&id=ef4869c2&", function () {
      api.rerender('ef4869c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/FirstAccess.vue"
export default component.exports